import { useState } from 'react';

const useLoading = () => {
  const [loading, reset] = useState(false);
  const [text, setText] = useState('Cargando...');

  const setLoading = (state) => {
    if (state === false) {
      setText('Cargando...');
    }
    reset(state);
  };

  return { loading, setLoading, text, setText };
};

export default useLoading;
